import type { ProductWithServices } from '../types';
import { priceTypeEnum } from '../generated';
import { getPriceDetails } from './price';

/**
 * Checks if given product is on sale.
 */
export const isOnSale = (product: ProductWithServices): boolean => {
  const onSaleDetails = [
    priceTypeEnum.EARLY_BIRD,
    // priceTypeEnum.FIRST_MINUTE,
    // priceTypeEnum.LAST_MINUTE,
    // priceTypeEnum.ULTRA_FIRST_MINUTE,
    // priceTypeEnum.ULTRA_LAST_MINUTE,
    // priceTypeEnum.GENERAL_DISCOUNT,
  ];

  const priceDetails = product.priceInformation?.priceDetails;

  if (typeof priceDetails === 'undefined') {
    return false;
  }

  const indexWithReducedPrice = priceDetails.findIndex(detail => {
    if (typeof detail.priceType === 'undefined') {
      return false;
    }

    return onSaleDetails.indexOf(detail.priceType) > -1;
  });

  return indexWithReducedPrice > -1;
};

/**
 * Returns sale related price details for given product.
 */
export const getSaleRelatedPriceDetails = (product: ProductWithServices) => {
  return getPriceDetails(product, priceTypeEnum.EARLY_BIRD);
};
